import messages from './messages.json';

type Messages = typeof messages.en;

export const getMessages = (locale: string): Messages => {
  const code = locale.split('-')[0]!;
  return (messages as any)[code] || messages.en;
};
